import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { contentTypes } from '../../langMap';

const HappeningListItem = ({ mainImage, type, title, color, slug, lang, edition }) => {
  const style = {
    color,
  };
  const imgSize = window.outerWidth < 1440 ? 'w280' : 'w400';
  const image = mainImage.replace(/original/, imgSize);
  return (
    <li className="c-happenings__item">
      <Link style={style} className="content-happenings__link" to={lang === 'ar' ? `/ar${slug}?edition=${edition}` : `${slug}?edition=${edition}`}>
        <div className="c-happening__item__inner">
          <img src={image} alt="1" />
          <div className="c-happenings__item__desc">
            <span className="c-happening__item__tag">{lang === 'ar' ? contentTypes[type] : type}</span>
            <h2 className="c-happening__item__title">{title}</h2>
          </div>
        </div>
      </Link>
    </li>
  );
};

export default HappeningListItem;

HappeningListItem.propTypes = {
  edition: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  mainImage: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./js/components/happenings/HappeningListItem.js